import type { CSSProperties } from 'react';

import motionStyles from './TemplateMotion.module.css';

export * from './TemplateCardSkeleton';

/** 列表卡片依次浮现：每项比上一项多等这么久（ms），与淡入时长同量级 */
export const TEMPLATE_CARD_STAGGER_MS = 60;
export const TEMPLATE_CARD_FADEIN_MS = 220;

/** 与 {@link templateCardStaggerFadeStyle} 同节点使用，绑定 module 内的 cardFadeIn keyframes */
export const templateCardStaggerFadeClassName = motionStyles.staggerFade;

/** `both`：delay 期间沿用 0% 透明度，避免仅依赖 `opacity-0` 与无效动画死锁 */
export const templateCardStaggerFadeStyle = (index: number): CSSProperties => ({
  animationDuration: `${TEMPLATE_CARD_FADEIN_MS}ms`,
  animationDelay: `${index * TEMPLATE_CARD_STAGGER_MS}ms`,
});
